<!--
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 14:52:08
 * @LastEditors: knight
 * @LastEditTime: 2022-02-09 17:59:12
-->
<template>
  <div>
    <Tabbar />
    <router-view></router-view>
  </div>
</template>

<script>
import Tabbar from './Tabbar';
export default {
  components: { Tabbar },
};
</script>

<style lang="less" scoped>
/deep/ .container {
  height: calc(100vh - 90px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
